import { $themeConfig } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
    verticalMenuDisplay: $themeConfig.layout.menu.display,
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },
    UPDATE_VERTICAL_MENU_DISPLAY(state, val) {
      state.verticalMenuDisplay = val
    },
  },
  actions: {},
}
